<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="branch_name"
                                       label="Branch name"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.branch_name" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="city"
                                       label="City"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.city" />

                        <FormInputText fieldName="address"
                                       label="Address"
                                       size="6"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.address" />

                        <FormInputText fieldName="postal_code"
                                       label="Postal code"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.postal_code" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="nip"
                                       label="NIP"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.nip" />
                        <FormInputText fieldName="phone"
                                       label="Phone"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.phone" />

                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.email" />
                        <FormInputToggleButton fieldName="is_active"
                                               label="Is active branch?"
                                               size="2"
                                               :isFormDisabled="isFormDisabled"
                                               v-model:field="crud.is_active" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Attachments"
                                          category="documents"
                                          :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'branches', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import { validation, initFormObj } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

const isAddAlertDialogOpen = ref(false);

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, initialData: { is_active: true } })
})

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
